var map = {
	"./a-que-huele-el-arte-de-maria.jpg": 67,
	"./combating.jpg": 68,
	"./efim.jpg": 69,
	"./empledesepan.jpg": 70,
	"./la-energia-solar.jpg": 71,
	"./smartplantic.jpg": 72,
	"./soy-sensible-soy-social.jpg": 73,
	"./terapias-de-realidad-virtual.jpg": 74
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23;